import { useEffect, useState } from 'react';
import { Box, Stack, TextField, Typography } from '@mui/material';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import FileDropzoneField from '@/shared/components/ui/FileDropzoneField';
import { ITicketMasivo } from '@/shared/interfaces/erp/tickets-soporte-clientes/gestion-ticket.interface';

export type PausarMasivoDialogProps = {
  open: boolean;
  masivo: ITicketMasivo | null;
  isLoading?: boolean;
  onClose: () => void;
  /**
   * Confirmación. Se invoca con el motivo y la lista de archivos. Si la
   * lista está vacía el caller usa el endpoint JSON clásico; si no, el
   * multipart.
   */
  onConfirm: (motivo: string, archivos: File[]) => void;
};

const PausarMasivoDialog: React.FC<PausarMasivoDialogProps> = ({
  open,
  masivo,
  isLoading = false,
  onClose,
  onConfirm,
}) => {
  const [motivo, setMotivo] = useState('');
  const [archivos, setArchivos] = useState<File[]>([]);

  useEffect(() => {
    if (!open) {
      setMotivo('');
      setArchivos([]);
    }
  }, [open]);

  const motivoTrim = motivo.trim();
  const disabled = isLoading || motivoTrim.length === 0;

  return (
    <ScrollableDialogProps
      open={open}
      onClose={onClose}
      onCloseIcon={onClose}
      title={masivo ? `Pausar Masivo ${masivo.codigo}` : 'Pausar Masivo'}
      contentNode={
        <Box sx={{ minWidth: 460 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Ingrese el motivo de la pausa. Mientras el masivo este pausado
            los clientes afectados veran una alerta amarilla en lugar del
            banner rojo de masivo activo.
          </Typography>
          <Stack spacing={2}>
            <TextField
              label="Motivo de pausa"
              multiline
              minRows={3}
              maxRows={6}
              fullWidth
              required
              autoFocus
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
              helperText="Obligatorio. Visible en el historial del masivo."
            />
            <FileDropzoneField
              value={archivos}
              onChange={setArchivos}
              helperText="Adjunte evidencias de la pausa (opcional). Imágenes, PDF, ZIP, Excel — máx. 50 MB c/u"
            />
          </Stack>
        </Box>
      }
      showConfirmBtn
      confirmTextBtn={
        archivos.length > 0
          ? `Pausar (${archivos.length} adjunto${archivos.length > 1 ? 's' : ''})`
          : 'Pausar'
      }
      confirmBtnColor="warning"
      confirmVariantBtn="contained"
      confirmDisabled={disabled}
      onConfirm={() => onConfirm(motivoTrim, archivos)}
    />
  );
};

export default PausarMasivoDialog;
